// TTS and chat configuration defaults.
export const defaultTtsConfig = {
  voice: 'onyx',
  model: 'tts-1',
  response_format: 'mp3',
  speed: 1.0,
  chatModel: 'gpt-4o-mini',
  chatMaxTokens: 600,
  temperature: 0.7,
  ttsChunkMinChars: 35,
  ttsChunkMaxChars: 240,
  apiKey: '',
  systemPrompt: 'Você é Zack, um assistente virtual amigável. Responda sempre em português do Brasil (pt-BR). Seja natural, prestativo e converse de forma descontraída.',
};

export function loadTtsConfig() {
  try {
    const saved = localStorage.getItem('three-gpt-tts-config');
    if (saved) {
      const config = { ...defaultTtsConfig, ...JSON.parse(saved) };
      if (!config.zackVoiceRevision) {
        if (config.voice === 'shimmer') config.voice = 'onyx';
        if (config.systemPrompt.startsWith('Você é uma assistente virtual amigável.')) config.systemPrompt = defaultTtsConfig.systemPrompt;
        config.zackVoiceRevision = 1;
      }
      if (config.response_format === 'pcm') {
        config.response_format = 'mp3';
      }
      if (config.ttsChunkMinChars > config.ttsChunkMaxChars) {
        config.ttsChunkMinChars = defaultTtsConfig.ttsChunkMinChars;
        config.ttsChunkMaxChars = defaultTtsConfig.ttsChunkMaxChars;
      }
      // Fix old/broken system prompts (English, Spanish, or missing accents)
      const savedPrompt = (config.systemPrompt || '').toLowerCase();
      const isPortuguese = savedPrompt.includes('português') || savedPrompt.includes('portugues') || savedPrompt.includes('pt-br') || savedPrompt.includes('brasileira');
      const isEnglish = savedPrompt.includes('you are') || savedPrompt.includes('english') || savedPrompt.includes('assistant');
      const isSpanish = savedPrompt.includes('usted') || savedPrompt.includes('español') || savedPrompt.includes('spanish');
      if (!isPortuguese || isEnglish || isSpanish) {
        console.warn('[TTS Config] System prompt was not in Portuguese. Resetting to default.');
        config.systemPrompt = defaultTtsConfig.systemPrompt;
      }
      return config;
    }
  } catch (e) {
    console.warn('Failed to load TTS config:', e);
  }
  return { ...defaultTtsConfig };
}

export function saveTtsConfig(config) {
  try {
    localStorage.setItem('three-gpt-tts-config', JSON.stringify(config));
  } catch (e) {
    console.warn('Failed to save TTS config:', e);
  }
}

export function resetTtsConfig() {
  localStorage.removeItem('three-gpt-tts-config');
  return { ...defaultTtsConfig };
}
